var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: {
        "margin-right": _vm.isFullScreen() ? "32px" : "32px",
        "margin-left": _vm.isFullScreen() ? "32px" : "32px",
      },
    },
    [
      _c("div", { staticClass: "chat-welcome-container" }, [
        _c("span", { staticClass: "bg" }),
        _c("div", { staticClass: "content" }, [
          _vm.customWelcome
            ? _c("h4", { domProps: { innerHTML: _vm._s(_vm.welcomeContent) } })
            : _c("h4", [
                _vm._v(" " + _vm._s(_vm.userInfo.nickName) + "，你好！"),
                _c("br"),
                _vm._v(
                  " 欢迎使用AI助手：" +
                    _vm._s(_vm.getInfo ? _vm.getInfo.name : "") +
                    " "
                ),
              ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }